//element ui
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/de'

//vue.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

//basic components
import App from './components/App.vue'
import Navigation from './components/pageLayout/Navigation.vue'

//location components
import Signin from './components/locations/Signin.vue'
import Users from './components/locations/Users.vue'
import Tasks from './components/locations/Tasks.vue'

import auth from './auth.js'

Vue.use(ElementUI, { locale })
Vue.use(VueRouter)
Vue.use(VueResource)

// Vue.http.headers.common['X-CSRF-TOKEN'] = document.getElementsByName('csrf-token')[0].getAttribute('content');
// Vue.http.options.root = 'http://localhost/schiffsregister/public';
Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token')

export default Vue

export const router = new VueRouter({
    routes: [
        /*
         * component locations requiring authentication, linked in navigation
         */
        {
            path: '/',
            name: 'users',
            component: Users,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/tasks',
            name: 'tasks',
            component: Tasks,
            props: true,
            meta: {
                requiresAuth: true
            }
        },

        /*
         * routes without authentication
         */
        {
            path: '/signin',
            name: 'signin',
            component: Signin
        }
        // {
        //     path: '/activate-email',
        //     name: 'activate-email',
        //     component: ActivateEmail
        // },
        // {
        //     path: '/activate-account',
        //     name: 'activate-account',
        //     component: ActivateAccount
        // },
        // {
        //     path: '/reset-password',
        //     name: 'reset-password',
        //     component: ResetPassword
        // },
    ]
})

//setup router security
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        // if there is jwt in localStorage but user seems to be not authenticated,
        // then double check via server if user auth (will happen on page reload)
        if (localStorage.getItem('id_token') !== null && auth.user.authenticated === false) {
            auth.verifyToken(checkPermissions)
        } else {
            checkPermissions()
        }

        function checkPermissions() {
            //if not authenticated -> redirect to signin
            if (auth.user.authenticated === false) {
                console.log('ERROR - Not authenticated, client is clearing token ...')
                auth.clearToken()
                next({ name: 'signin' })

                //if not has property permission -> handle permission
            }
            if (to.meta.hasOwnProperty('permission')) {
                if (auth.user.authenticated && auth.user.profile.permissions[to.meta.permission]) {
                    next()
                } else {
                    console.log('ERROR - No permissions, client is clearing token ...')
                    auth.clearToken()
                    next({ name: 'signin' })
                }
            } else {
                // console.log("PASS - Basic user is allowed to access this route");
                next()
            }
        }
    } else {
        next()
    }
})

//create interceptor for general handling of 401
Vue.http.interceptors.push(function (request, next) {
    next(function (response) {
        if (response.status === 401) {
            console.log('ERROR - 401 client will clear token ...')
            auth.clearToken()
            return response
        }
    })
})

//initialize VUE instance
// export const VueInstance = new Vue({
export const VueInstance = new Vue({
    el: '#app',
    router: router,
    render: (app) => app(App),
    components: {
        navigation: Navigation
    }
})
